<template>
  <div class="side-nav">
    <!-- 品牌 Logo 区 -->
    <div class="nav-item logo-item">
      <img src="../assets/logo/logo1.png" class="logo-img" />
    </div>
    
    <!-- 咨询热线区 -->
    <div class="nav-item contact-item">
      <i class="el-icon-phone icon"></i>
      <span class="title">咨询热线</span>
      <span class="phone">15860347027</span>
    </div>

    <!-- 微信联系区 -->
    <div class="nav-item wechat-item">
      <div class="wechat-header">
        <img src="../assets/homePub/wechatlogo.png" class="wechat-icon" />
        <span>徐先生</span>
      </div>
      <img src="../assets/homePub/wechat.jpg" class="qrcode" />
    </div>

    <!-- 快速回顶区 -->
    <div class="nav-item back-top" @click="backTop">
      <i class="el-icon-arrow-up"></i>
      <span>回到顶部</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sideNav',
  methods: {
    backTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
}
</script>

<style scoped>
.side-nav {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  width: 140px;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  text-align: center;
  border: 1px solid #ebeef5;
}

.nav-item {
  padding: 16px 10px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.nav-item:last-child {
  border-bottom: none;
}

.logo-img {
  width: 85%;
  height: auto;
  object-fit: contain;
}

.contact-item {
  color: #333;
}
.contact-item .icon {
  font-size: 26px;
  color: #409eff;
  margin-bottom: 6px;
}
.contact-item .title {
  font-size: 13px;
  color: #909399;
  margin-bottom: 4px;
}
.contact-item .phone {
  font-size: 14px;
  font-weight: 600;
  color: #f56c6c;
}

.wechat-item {
  padding: 15px 10px 12px;
}
.wechat-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 13px;
  color: #333;
  margin-bottom: 10px;
}
.wechat-icon {
  width: 22px;
  height: 22px;
}
.qrcode {
  width: 100px;
  height: 100px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 2px;
  background: #fff;
}

.back-top {
  cursor: pointer;
  color: #909399;
  transition: all 0.3s;
  background-color: #f8f9fa;
  padding: 12px 10px;
}
.back-top:hover {
  background-color: #409eff;
  color: #fff;
}
.back-top i {
  font-size: 20px;
  margin-bottom: 4px;
}
.back-top span {
  font-size: 13px;
}

/* 在中小型设备或较窄的电脑屏幕中自动将其隐藏避免遮挡界面 */
@media (max-width: 1100px) {
  .side-nav {
    display: none;
  }
}
</style>